import React, { FC } from 'react';

const TwoFA: FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="205"
      height="230"
      viewBox="0 0 205 230"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M156.72 204.699H47.5358C21.4238 204.699 0.111816 183.451 0.111816 157.275V48.1554C0.111816 22.0434 21.3598 0.731445 47.5358 0.731445H156.72C182.832 0.731445 204.144 21.9794 204.144 48.1554V157.339C204.144 183.451 182.896 204.699 156.72 204.699Z"
        fill="#EFF2F4"
      />
      <path
        d="M154.48 181.147H49.648C38.448 181.147 29.36 172.059 29.36 160.859C29.36 149.659 38.448 140.571 49.648 140.571H154.48C165.68 140.571 174.768 149.659 174.768 160.859C174.768 172.059 165.68 181.147 154.48 181.147Z"
        fill="#FF2B85"
      />
      <path
        d="M139.824 31.5794L139.376 31.3874L138.928 31.2594L112.496 24.7954C108.912 23.8994 105.264 23.4514 101.552 23.4514C97.7121 23.4514 93.9361 23.9634 90.2241 24.8594L65.1361 31.2594L64.6881 31.3874L64.3041 31.5794C58.9921 33.8194 55.5361 38.8114 55.5361 44.3794V68.0594C55.5361 80.9874 59.5041 93.0834 67.0561 103.003C75.6321 114.267 87.0241 121.371 100.976 124.059L102.128 124.251L103.28 124.059C117.104 121.371 128.432 114.395 137.008 103.259C144.688 93.2754 148.72 81.0514 148.72 68.0594V44.3794C148.592 38.8114 145.136 33.8194 139.824 31.5794Z"
        fill="#F7C6CC"
      />
      <path
        d="M111.088 30.62C104.752 29.084 98.032 29.0839 91.696 30.6839L66.608 37.084C63.472 38.4279 61.488 41.244 61.488 44.38V68.06C61.488 79.196 64.816 90.204 71.792 99.42C77.936 107.548 87.472 115.42 102.064 118.236C116.528 115.42 126 107.676 132.144 99.676C139.184 90.46 142.64 79.324 142.64 68.124V44.4439C142.64 41.308 140.656 38.492 137.52 37.148L111.088 30.62Z"
        fill="#FF2B85"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M117.597 60.5555C118.807 61.6758 118.881 63.5655 117.76 64.7762L99.5204 84.4882C98.9713 85.0815 98.2052 85.427 97.397 85.4456C96.5888 85.4642 95.8076 85.1544 95.2318 84.587L86.3998 75.883C85.2249 74.7251 85.2111 72.8341 86.3689 71.6593C87.5268 70.4844 89.4178 70.4706 90.5926 71.6284L97.2294 78.169L113.376 60.7192C114.496 59.5085 116.386 59.4352 117.597 60.5555Z"
        fill="white"
      />
      <path
        d="M83.4399 202.588L98.8639 227.356C100.4 229.852 103.984 229.852 105.584 227.484L123.248 200.924"
        fill="#EFF2F4"
      />
      <path
        d="M64.2398 157.084L59.5038 159.324V154.524H56.3038V159.324L51.5678 157.404L50.3518 160.348L55.5358 162.396L52.2078 166.3L54.6398 168.348L58.0318 164.316L61.4238 168.412L63.8558 166.364L60.5278 162.332L65.5838 159.964L64.2398 157.084Z"
        fill="white"
      />
      <path
        d="M93.6158 157.084L88.8798 159.324V154.524H85.6798V159.324L80.9438 157.404L79.7278 160.348L84.9118 162.396L81.5838 166.3L84.0158 168.348L87.4078 164.316L90.7998 168.412L93.2318 166.364L89.9038 162.332L94.9598 159.964L93.6158 157.084Z"
        fill="white"
      />
      <path
        d="M122.992 157.084L118.256 159.324V154.524H115.056V159.324L110.32 157.404L109.104 160.348L114.288 162.396L110.96 166.3L113.392 168.348L116.784 164.316L120.176 168.412L122.608 166.364L119.28 162.332L124.336 159.964L122.992 157.084Z"
        fill="white"
      />
      <path
        d="M153.712 159.964L152.368 157.084L147.632 159.324V154.524H144.432V159.324L139.696 157.404L138.544 160.348L143.664 162.396L140.4 166.3L142.768 168.348L146.224 164.316L149.552 168.412L151.984 166.364L148.656 162.332L153.712 159.964Z"
        fill="white"
      />
    </svg>
  );
};

export default TwoFA;
